
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("a6LTg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $74f0b51e33500e69$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $i7phc = parcelRequire("i7phc");

var $4xKSz = parcelRequire("4xKSz");

var $a34pD = parcelRequire("a34pD");
const $74f0b51e33500e69$var$ForgeHeaderModule = ({ page: page, portalId: portalId, projectId: projectId, requestKey: requestKey, requestTypeId: requestTypeId, noWrapper: noWrapper, allowCustomPadding: allowCustomPadding, skipHelpCenterWrapper: skipHelpCenterWrapper })=>{
    return /*#__PURE__*/ $bSJIT.createElement((0, $a34pD.ForgeRunnerContainer), {
        allowCustomPadding: allowCustomPadding
    }, /*#__PURE__*/ $bSJIT.createElement((0, $4xKSz.ForgeRunnerModule), {
        type: (0, $i7phc.PORTAL_HEADER_MODULE),
        page: page,
        portalId: portalId,
        projectId: projectId,
        requestTypeId: requestTypeId,
        requestKey: requestKey,
        noWrapper: noWrapper,
        skipHelpCenterWrapper: skipHelpCenterWrapper
    }), /*#__PURE__*/ $bSJIT.createElement((0, $4xKSz.ForgeRunnerModule), {
        type: (0, $i7phc.PORTAL_SUBHEADER_MODULE),
        page: page,
        portalId: portalId,
        projectId: projectId,
        requestTypeId: requestTypeId,
        requestKey: requestKey,
        noWrapper: noWrapper,
        skipHelpCenterWrapper: skipHelpCenterWrapper
    }));
};
var $74f0b51e33500e69$export$2e2bcd8739ae039 = $74f0b51e33500e69$var$ForgeHeaderModule;

});
parcelRegister("4xKSz", function(module, exports) {
$parcel$export(module.exports, "ForgeRunnerModule", () => $265d58fb0a861da2$export$c75218f48f4de8c0);

var $cVM5r = parcelRequire("cVM5r");

var $cJJTb = parcelRequire("cJJTb");

const $265d58fb0a861da2$export$c75218f48f4de8c0 = (0, $cVM5r.default)({
    loader: (0, $cJJTb.lazyForPaint)(()=>(parcelRequire("e3NwR")), {
        moduleId: "./src/view/forge-ui/forge-runner/forge-runner.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("e3NwR", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("gN16R").then(()=>parcelRequire('iCTDK'));

});


parcelRegister("a34pD", function(module, exports) {
$parcel$export(module.exports, "ForgeRunnerContainer", () => $2a4d4fb1ba0685c5$export$1c813ec4dd10a33c);
$parcel$export(module.exports, "StyledForgeContainer", () => $2a4d4fb1ba0685c5$export$1b5662b649e8dd77);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $4v2A7 = parcelRequire("4v2A7");

var $lFpPv = parcelRequire("lFpPv");

var $fU62V = parcelRequire("fU62V");

var $a7Tmb = parcelRequire("a7Tmb");
const $2a4d4fb1ba0685c5$export$1c813ec4dd10a33c = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-yy3s2n-0"
})`padding-top:0;padding-bottom:0;${({ allowCustomPadding: allowCustomPadding })=>allowCustomPadding && `
            > * {
                padding-top: ${"var(--ds-space-300, 24px)"};
            }
            > :first-child {
                padding-top: ${(0, $lFpPv.isIncreasedFlexibilityEnabled)() ? "var(--ds-space-400, 32px)" : "var(--ds-space-300, 24px)"};
            }
            > :last-child {
                padding-bottom: ${(0, $lFpPv.isIncreasedFlexibilityEnabled)() ? "var(--ds-space-400, 32px)" : "var(--ds-space-300, 24px)"};
            }
        `}`;
const $2a4d4fb1ba0685c5$export$1b5662b649e8dd77 = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-yy3s2n-1"
})`margin:auto;${$fU62V.borderBox};margin-top:${(props)=>props.noWrapper ? 'auto' : "var(--ds-space-600, 48px)"};max-width:${(0, $a7Tmb.sizes).small}px;padding-left:${"var(--ds-space-600, 48px)"};padding-right:${"var(--ds-space-600, 48px)"};width:100%;`;

});



//# sourceMappingURL=portal-forge-ui-header.f5ecd324.js.map
